define(function(require, exports, module) {
    'use strict';
    var _ = require('underscore');
    var $ = require('j');
    var AbstractTracker = require('modules/trackers/abstract.tracker');
    var core = require('core');

    var GameTracker = AbstractTracker.extend({
        defaults: {
            gameWillBePlayedMaybe: {},
            $el: $('#application')
        },

        events: [
            'gamePortletPersonalizedGrid',
            'gamePortletDisplay',
            'gamePortletSearch',
            'gamePortletPage',
            'gamePortletView',
            'gamePortletCategoryChange',
            'gamePortletSort',
            'gameFavoritesChange',
            'gameGameDisplay',
            'gameGameLaunch'
        ],

        subscribe: function() {
            this.listenTo(core, {
                'page:rendered': this._handlePageRender,
                'game:launch:maybe': this._handleGameLaunchMaybe,
                'game:launch': this._handleGameLaunch
            });
        },

        /**
         * Get web content id if there is one for particular game
         *
         * @param  {jBone} $game
         * @return {String|Undefined}
         */
        getWebContentId: function($game) {
            var $webContent = $game.parents('[data-web-content-id]');
            if ($webContent.length) {
                return $webContent.data('webContentId');
            }
        },

        _handleGameLaunchMaybe: function(game) {
            this.set('gameWillBePlayedMaybe', game);
        },

        _handleGameLaunch: function(game, isRealMode, queryString, options) {
            if (game.gameCode !== this.get('gameWillBePlayedMaybe').gameCode && !(options && options.isReactGame)) {
                return;
            }

            var gameWillBePlayedMaybe = this.get('gameWillBePlayedMaybe');
            var gameLaunchEvent = {
                launchType: isRealMode ? 'Real' : 'Demo',
                gameCode: game.gameCode,
                gameName: game.name
            };

            if (options && options.isReactGame) {
                ['container', 'gameFeed', 'gameName'].forEach(function(fieldName) {
                    gameLaunchEvent[fieldName] = options[fieldName];
                });
            } else {
                ['container', 'webContentId', 'feedName'].forEach(function(fieldName) {
                    if (gameWillBePlayedMaybe[fieldName]) {
                        gameLaunchEvent[fieldName] = gameWillBePlayedMaybe[fieldName];
                    }
                });
            }

            this.track('gameGameLaunch', gameLaunchEvent);
        },

        _getGames: function($porletContainer) {
            return $porletContainer
                .find('.fn-launch-game')
                .reduce(function(games, game) {
                    var $game = $(game);
                    var $gameItem = $game;
                    var $gameWrapper = $game.parents('.fn-game-item-wrapper');
                    if ($gameWrapper.length) {
                        $gameItem = $gameWrapper;
                    }
                    //TODO add visibility check when correctly implemented `$.isInViewport()`
                    if (!games.includes($gameItem)) {
                        var portletId = $porletContainer.data('portletId');
                        var gameCode = $game.data('gameCode');
                        var gameInConfiguration = Playtech.Variables.gamesConfiguration[gameCode];
                        var gameName = gameInConfiguration && gameInConfiguration.name || $game.data('name') || '';
                        var newGame = {
                            container: $porletContainer.data('portletId'),
                            gameCode: gameCode,
                            gameName: gameName,
                            hash: portletId + $gameItem.html()
                        };
                        var webContentId = this.getWebContentId($game);

                        if (webContentId) {
                            newGame.webContentId = webContentId;
                        }

                        games.push(newGame);
                    }

                    return games;
                }.bind(this), []);
        },

        _handlePageRender: function() {
            this._trackGameDisplay();
            this._trackGamePortletDisplay();
        },

        _trackGamePortletDisplay: function() {
            this.get('$el')
                .find('[data-portlet-type="games-info"]')
                .forEach(function(gamePortlet) {
                    $(gamePortlet).find('.fn-games')
                        .forEach(function(gamesContainer) {
                            this.track(
                                'gamePortletDisplay',
                                {
                                    container: gamePortlet.dataset.portletId,
                                    feedName: gamesContainer.dataset.feedName
                                }
                            );
                        }, this);
                }, this);
        },

        _trackGameDisplay: function() {
            this.get('$el')
                .find('.portlet-wrapper')
                .filter(function(portlet) {
                    return portlet.dataset.portletType === 'games-info';
                })
                .forEach(function(gameContainer) {
                    this._getGames($(gameContainer))
                        .forEach(function(game) {
                            this.track('gameGameDisplay', _.omit(game, 'hash'));
                        }, this);
                }.bind(this));

        }
    });

    module.exports = GameTracker;
});
